var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showLogin() && _vm.$route.path !== "/",
          expression: "showLogin() && $route.path !== '/'"
        }
      ],
      staticClass: "top-right",
      attrs: { id: "user" }
    },
    [
      _c("img", {
        staticClass: "avatar",
        attrs: { src: require("@/assets/img/avatar.svg?data"), alt: "Avatar" }
      }),
      _vm._v(" " + _vm._s(_vm.showName()) + "\n  "),
      _c(
        "button",
        {
          staticClass: "btn btn-sm btn-primary",
          on: {
            click: function($event) {
              return _vm.logOut()
            }
          }
        },
        [_vm._v("Logga ut")]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73968b0a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73968b0a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/User.vue
// module id = null
// module chunks = 